import { useEffect } from 'react';

const SEO = ({ title, description }) => {
  useEffect(() => {
    // Dynamic page title
    const baseTitle = 'GadgetStore | Premium Electronics & Tech Gadgets';
    document.title = title ? `${title} | GadgetStore` : baseTitle;

    // Dynamic meta description
    if (description) {
      let metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) {
        metaDesc.setAttribute('content', description);
      }
    }
  }, [title, description]);

  return null;
};

export default SEO;
